// extracted by mini-css-extract-plugin
export default {"dialogMultiButton":"DeleteFavoriteDialog_dialogMultiButton__F5qwM"};